<!-- <div class="content-body">-->
<!-- <div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Nuevo Producto</h4>
        </div>
        <div class="card-body">
          <mat-dialog-content>
            <div id="product-item" class="product-item-container">
              <app-add-menu-product-from></app-add-menu-product-from>
            </div>
          </mat-dialog-content>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!--</div> -->

<!-- <mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cerrar</button>
  <button mat-button color="primary">Crear</button>
</mat-dialog-actions> -->

<mat-dialog-content class="dialog-content">
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Crear Producto</h4>
    </div>
    <div class="card-body">
      <div class="dialog-body">
        <app-add-menu-product-from
          [productInfo]="productInfo"
          (created)="closeDialog()"
          (canceled)="closeDialog()"
        ></app-add-menu-product-from>
      </div>
    </div>
  </div>
</mat-dialog-content>
